module.exports = __webpack_public_path__ + "img/logo-de-toefl.a5c3c2f3.jpg";